export const MIN_DRIVER_AGE = 21;

export function formatAed(amount) {
  return `AED ${Number(amount || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatBookingDateTime(date) {
  if (!date) return "";
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toLocaleString("en-GB", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

function pluralize(count, word) {
  return `${count} ${word}${count === 1 ? "" : "s"}`;
}

// Mirrors the price lines the backend uses in the confirmation email.
export function getPriceLines(pricing) {
  if (!pricing) return [];

  const lines = [];
  if (pricing.months > 0) {
    lines.push({
      label: `${pluralize(pricing.months, "month")} x ${formatAed(
        pricing.monthlyRate,
      )}`,
      value: pricing.months * pricing.monthlyRate,
    });
  }
  if (pricing.extraDays > 0) {
    lines.push({
      label: `${pluralize(pricing.extraDays, "day")} x ${formatAed(
        pricing.dailyRate,
      )}`,
      value: pricing.extraDays * pricing.dailyRate,
    });
  }

  return lines;
}

export function getRentalDaysLabel(pricing) {
  return pricing ? pluralize(pricing.rentalDays, "day") : "";
}

// Latest date of birth that still makes the driver MIN_DRIVER_AGE today.
export function getLatestDateOfBirth() {
  const date = new Date();
  date.setFullYear(date.getFullYear() - MIN_DRIVER_AGE);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}
